export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ hxPreOrderStatus }) => {
      return !['N', 'R'].includes(hxPreOrderStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ hxPreOrderStatus }) => {
      return !['N', 'R'].includes(hxPreOrderStatus)
    },
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ hxPreOrderStatus }) => {
      return !['N', 'R'].includes(hxPreOrderStatus)
    },
  },
  {
    text: that.$l('menu_text_review') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'review',
    allow: 'Y',
    disabled: ({ hxPreOrderStatus }) => hxPreOrderStatus !== 'S',
  },
  {
    text: that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'R',
    disabled: ({ hxPreOrderStatus }) => hxPreOrderStatus !== 'S',
  },
]
